export const breakpoints = {
  md: 900,
  desktop: 1025,
  lg: 1200,
  'page-max': 1440,
}
